import React, {useEffect} from "react"

const BeforeUnload = ({children}) => {
  useEffect(() => {
    const listener = (event) => {
        event.preventDefault();
      if (event.defaultPrevented) {
        return (event.returnValue = '');
      }
    };

    window.addEventListener('beforeunload', listener);

    return () => {
      window.removeEventListener('beforeunload', listener);
    };
  }, []);

  return (
    <>
      {children}
    </>
  )
}

export default BeforeUnload
